import React, { useCallback, useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { Row, Col, Table, Spinner, Button, Form } from 'react-bootstrap';
import { FaArrowCircleLeft, FaPlusCircle, FaTrashAlt } from 'react-icons/fa';
import { PositionEmployee } from '../../data/PositionEmployeeLog/schemas/PositionEmployeeLog.schema'
import { formatYMDToDMY } from '../../modules/Common'

type Props = {
    isOpen?: boolean;
    onClose?: () => void;
    positionEmployeeLog?: PositionEmployee[];
};

function PositionEmployeeLogModal(props: Props) {
    const { isOpen, onClose, positionEmployeeLog } = props;

    console.log(positionEmployeeLog)

    return (
        <Modal
            className="h-[90%] w-[98%] max-w-[1920px]"
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalHeader>

                <p className="text-base font-semibold">Change Log</p>
                {/*<div style={{ display: 'inline-block', float: 'right', marginRight: 10 }}>*/}
                {/*    <Button*/}
                {/*        variant="success"*/}
                {/*        size="sm"*/}
                {/*        onClick={() => onClose && onClose()}*/}
                {/*    >*/}
                {/*        <FaArrowCircleLeft />&nbsp;Back*/}
                {/*    </Button>*/}
                {/*</div>*/}

            </ModalHeader>
            <ModalBody>
                <div style={{ overflowX: 'scroll' }} className='mt-2'>
                    <Table className="table-bordered table-hover">
                        <thead>
                            <tr
                                className="table-active thead-light text-nowrap text-center"
                                style={{ width: '100%' }}
                            >
                                <th>Time</th>
                                <th>Subject</th>
                                <th>Action</th>
                                <th>Object</th>
                            </tr>
                        </thead>
                        <tbody>
                            {positionEmployeeLog && positionEmployeeLog.sort((a, b) => (a.created_on ?? '') < (b.created_on ?? '') ? 1 : -1).map((item, idx) => {
                                const actionStyle = item.action === 'added'
                                    ? { backgroundColor: '#d4edda', color: '#155724' }
                                    : item.action === 'edit'
                                    ? { backgroundColor: '#d1ecf1', color: '#0c5460' }
                                    : item.action === 'deleted'
                                    ? { backgroundColor: '#f8d7da', color: '#721c24' }
                                    : {};

                                return (
                                <tr id={"addr" + idx} key={idx} style={actionStyle}>
                                    <td>
                                        {formatYMDToDMY(item.created_on ?? '')}
                                    </td>
                                    <td>
                                        {item.created_by}
                                    </td>
                                    <td>
                                        <b>{item.action}</b>
                                    </td>
                                    <td>
                                        {item.details && item.details.map((detail, idy) => (
                                            <>
                                                {
                                                    detail.columnName != 'sid' &&
                                                    <Row className="show-grid">
                                                        <Col md={1}>
                                                            {' username '}
                                                        </Col>
                                                        <Col md={2}>
                                                            <b>{detail.id}</b>
                                                        </Col>
                                                        <Col md={1}>
                                                            {item.action == 'edit' ? ' change ' : (item.action == 'added' ? 'add' : '')}
                                                        </Col>
                                                        <Col md={2}>
                                                            <b>{detail.columnName}</b>
                                                        </Col>
                                                        <Col md={1}>
                                                            {item.action == 'edit' ? ' from ' : ''}
                                                        </Col>
                                                        <Col md={2}>
                                                            <b>{detail.fromValue}</b>
                                                        </Col>
                                                        <Col md={1}>
                                                            {item.action == 'edit' || item.action == 'added' ? ' to ' : ''}
                                                        </Col>
                                                        <Col md={2}>
                                                            <b>{detail.toValue}</b>
                                                        </Col>
                                                    </Row>
                                                }
                                            </>
                                        ))}
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </ModalBody >
            <ModalFooter className="mt-auto flex justify-end gap-4 px-2">
                <Button
                    onClick={() => onClose && onClose()}
                    variant="outline-danger"
                    size="sm"
                >
                    Close
                </Button>
            </ModalFooter>
        </Modal >
    );
};

export default PositionEmployeeLogModal;